import { Navigate } from "react-router-dom";
import { path as routePath } from "src/constants/path";
import { useAppSelector } from "src/redux/store";

type AuthRouteProps = {
  element: () => JSX.Element;
  path?: string;
  exact?: boolean;
  index?: boolean;
  isAuthRoute?: boolean;
};

const AuthRoute = ({
  element: Component,
  isAuthRoute = false,
  path = "/",
  exact = false,
  index = false,
  ...rest
}: AuthRouteProps) => {
  const user = useAppSelector((state: any) => state.root.user);

  return user.isLoggedIn ? (
    <Navigate to={routePath.home} />
  ) : (
    <Component {...rest} />
  );
};

export default AuthRoute;
